import { ProductLocationDto } from "@/core/api/generated/v1";

import BaseEntityAutocompleteOrCreate, {
  AutocompleteType,
  BaseEntityAutocompleteOrCreateInheritableProps,
} from "../components/BaseEntityAutocompleteOrCreate";
import ProductLocationCreateUpdate, {
  ProductLocationCreateUpdateProps,
} from "./ProductLocationCreateUpdate";
import ProductLocationCreateUpdateModal from "./ProductLocationCreateUpdateModal";
import ProductLocationsAutocomplete, {
  ProductLocationsAutocompleteProps,
} from "./ProductLocationsAutocomplete";

type Props = BaseEntityAutocompleteOrCreateInheritableProps<
  ProductLocationDto,
  ProductLocationCreateUpdateProps["defaultValues"],
  ProductLocationsAutocompleteProps,
  Pick<ProductLocationCreateUpdateProps, "defaultValues">
>;

export default function SelectOrCreateProductLocation({ ...otherProps }: Props) {
  return (
    <BaseEntityAutocompleteOrCreate<
      ProductLocationDto,
      ProductLocationCreateUpdateProps["defaultValues"],
      ProductLocationsAutocompleteProps,
      Pick<ProductLocationCreateUpdateProps, "defaultValues">
    >
      autocompleteType={AutocompleteType.Multiple}
      getDefaultValues={(params) => params.createUpdateProps?.defaultValues}
      renderAutocomplete={(params) => (
        <ProductLocationsAutocomplete
          {...params.autocompleteProps}
          withCreate
          createOptionTitle={(inputValue) => `Create new sales location "${inputValue}"`}
          onCreate={(newOption) => {
            params.setDefaultValues({
              ...params.defaultValues,
              name: newOption?.inputValue || params.defaultValues?.name || undefined,
            });
            params.setIsCreate(true);
            params.onCreateStart && params.onCreateStart();
          }}
        />
      )}
      renderCreateUpdate={(params) => (
        <ProductLocationCreateUpdate
          {...params.createUpdateProps}
          defaultValues={params.defaultValues}
          onCreate={params.onCreate}
          onSave={(newValue) => {
            params.setIsCreate(false);
          }}
        />
      )}
      renderCreateUpdateModal={(params) => (
        <ProductLocationCreateUpdateModal
          open={params.isCreate}
          onClose={() => params.setIsCreate(false)}
          createUpdateProps={{
            ...params.createUpdateProps,
            defaultValues: params.defaultValues,
            onCreate: params.onCreate,
            onSave: (newValue) => {
              params.setIsCreate(false);
            },
          }}
        />
      )}
      {...otherProps}
    />
  );
}
